<template>
  <div>
    <el-row :gutter="12" class="mt-2" v-loading.fullscreen.lock="pushcartProducts.isLoading">
      <el-row type="flex" justify="space-between" align="middle" class="mb-4">
        <p class="category-title ma-0">Pushcart Product
          <el-button
            @click="$router.push('/pushcartproduct/create')"
            type="warning"
            icon="el-icon-plus"
            circle
            size="small"
            class="ml-3"
          ></el-button>
        </p>

        <el-col :span="16">
          <el-row type="flex" justify="end">
            <el-select
              v-model="optionView"
              size="small"
              placeholder="Select"
              class="mr-2"
              @change="
            e => {
              toAnotherPage(page, e, form.search, valueStatus), settingTable(page, e);
            }
          "
              style="width: 100px"
            >
              <el-option
                v-for="item in optionsView"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>

            <el-input
              size="small"
              v-model="form.search"
              placeholder="Search by retur id or customer name"
              style="width: 200px"
              class="mr-2"
              @keyup.enter.native="onSearch"
            ></el-input>
          </el-row>
        </el-col>
      </el-row>

      <el-col :span="24">
        <el-table empty-text="Tidak ada data" :data="pushcartProducts.data" style="width: 100%">
          <el-table-column sortable prop="image" label="Image">
            <template slot-scope="scope">
              <el-image style="width: 70px; height: 70px" :src="scope.row.image" fit="cover"></el-image>
            </template>
          </el-table-column>
          <el-table-column sortable prop="name" label="Name" width="180"></el-table-column>
          <el-table-column sortable prop="price" label="Price" width="180"></el-table-column>
          <el-table-column sortable prop="discountType" label="Discount Type" width="180"></el-table-column>
          <el-table-column sortable prop="discount" label="Discount" width="180"></el-table-column>
          <el-table-column sortable prop="status" label="Status" width="180">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.status"
              placeholder="Select"
              @change="(e) => handleUpdate(e, scope.row.itemCode)"
            >
              <el-option
                v-for="item in optionsActive"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
          <el-table-column fixed="right" align="center" label="Operations" width="100">
            <template slot-scope="scope">
              <el-button
                type="warning"
                size="mini"
                icon="el-icon-edit"
                circle
                @click="$router.push(`/customer-new/edit/${scope.row.id}`)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end">
          <el-pagination
            layout="prev, pager, next"
            :total="pushcartProducts.count"
            :current-page="parseInt(page)"
            @current-change="
            e => {
              toAnotherPage(e, optionView, form.search, valueStatus), settingTable(e, optionView);
            }
          "
            :page-size="parseInt(optionView)"
          ></el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      dialog: false,
      id: null,
      form: {
        search: ""
      },
      optionsActive: [
        {
          value: true,
          label: "Active"
        },
        {
          value: false,
          label: "No Active"
        }
      ],
      optionsView: [
        {
          value: 1,
          label: "1"
        },
        {
          value: 2,
          label: "2"
        },
        {
          value: 75,
          label: "75"
        },
        {
          value: 100,
          label: "100"
        },
        {
          value: 125,
          label: "125"
        },
        {
          value: 150,
          label: "150"
        }
      ],
      optionView: 25,
      optionsStatus: [
        {
          value: 'done',
          label: "Done"
        },
        {
          value: 'on_progress',
          label: "On Progress"
        },
        {
          value: 'payment_confirmation',
          label: "Menunggu Pembayaran"
        },
        {
          value: 'pending',
          label: "Tertunda"
        },
        {
          value: 'delivery',
          label: "Dalam Pengiriman"
        },
      ],
      valueStatus: 'on_progress',
      page: 1
    };
  },
  mounted() { },
  methods: {
    ...mapActions({
      getPushcartProducts: "pushcartProduct/GetPushcartProducts",
      deletePushcartProduct: "pushcartProduct/DeletePushcartProduct"
    }),
    showDialog(id) {
      (this.id = id), (this.dialog = true);
    },
    toAnotherPage(page, limit, search) {
      this.$router.push({ path: "/customer-new", query: { page: page, limit: limit, search: search } });
    },
    onSearch() {
      this.$router.replace({ path: "/customer-new", query: { page: 1, limit: 25, search: this.form.search } });
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
          search: this.form.search
        }
      };
      this.getPushcartProducts(option);
    },
    settingTable() {
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      this.form.search = this.$router.history.current.query.search;
      this.valueStatus = this.$router.history.current.query.status;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
          search: this.form.search,
        }
      };
      if (this.valueStatus !== '') {
        option = {
          params: {
            ...option.params,
          }
        }
      }
      this.getPushcartProducts(option);
    }
  },
  computed: {
    ...mapState({
      pushcartProducts: state => state.pushcartProduct.pushcartProducts
    })
  },
  created() {
    this.page = this.$router.history.current.query.page || 1;
    this.optionView = this.$router.history.current.query.limit || 25;
    this.form.search = this.$router.history.current.query.search || '';
    this.valueStatus = this.$router.history.current.query.status || '';
    let option = {
      params: {
        page: this.page,
        limit: this.optionView,
        search: this.form.search,
      }
    };
    this.getPushcartProducts(option);
  }
};
</script>

<style>
.custom-container {
  padding-top: 0px !important;
}
.custom-table thead {
  background-color: #dee2e6;
}
.custom-table thead tr th {
  font-weight: bold;
}
.custom-table tbody {
  background-color: #f8f9fa;
}
</style>
